/**
 * @fileoverview Data model to hold a user's active license selections.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

export class FeatureSelection {
  /**
   * @return {!FeatureSelection}
   */
  static empty() {
    return new FeatureSelection({
      ids: [],
      displayNames: [],
      skipSetup: false,
    });
  }

  /**
   * @param {{
   *   ids: !Array<number>,
   *   displayNames: !Array<string>,
   *   skipSetup: boolean,
   * }} params
   */
  constructor(params) {
    /** @type {!Array<number>} */
    this.ids = params.ids;
    /** @type {!Array<string>} */
    this.displayNames = params.displayNames;
    /** @type {boolean} */
    this.skipSetup = params.skipSetup;
  }

  /**
   * @return {!FeatureSelectionJson}
   */
  toJSON() {
    return {
      'ids': this.ids,
      'displayNames': this.displayNames,
    };
  }
}

/**
 * @dict
 * @typedef {{
 *   ids: !Array<number>,
 *   displayNames: !Array<string>,
 * }}
 */
export let FeatureSelectionJson;
